

















































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";
import TDSButton from "@/components/common/TDSButton.vue";
import TableList from "@/components/partials/TableList.vue";
import Inputfield from "@/components/partials/Inputfield.vue";
import TDSModal from "@/components/partials/TDSModal/TDSModal.vue";
import PackageCard from "@/components/partials/PackageCard.vue";
import PricingBanner from "../partials/PricingPage/PricingBanner.vue";
import { Product } from "@/interfaces/entities/Product";
import { emojiFlag } from "@/util/emojiFlag";
import ServerFilterPanel, { ActiveDataPackageFilters } from "@/components/partials/ServerFilterPanel.vue";
import Pagination from "@/components/partials/Pagination.vue";
import TDSSpinner from "@/components/common/TDSSpinner.vue";
import { coverageTypeOf } from "@/util/filterUtils";
import { tools } from "@/util/tools";

@Component({
    components: {
        ServerFilterPanel,
        Pagination,
        TDSModal,
        Inputfield,
        TableList,
        DefaultLayout,
        TDSButton,
        PackageCard,
        PricingBanner,
        TDSSpinner
    }
})
export default class AddPackages extends Vue {
    private isLoading: boolean = true;
    private cartBoxIsOpen: boolean = false;
    // private bulkDiscount: BulkDiscount | null = null;
    // private bulkDiscountInfo: BulkDiscountInfo[] = [];
    private selectedAmounts: { [productId: string]: number } = {};
    private stepsCardVisible: boolean = false;
    private showPackageModal: boolean = false;
    private modalPackage?: Product;
    private tableColumns: object = {
        detail: { label: "", sortable: false, width: "32px", align: "center" },
        coverage: { label: this.$t("pricing.table.dataPackage") as string, sortable: true, sortBy: (product: Product) => product.countrySet },
        sizeValue: { label: this.$t("pricing.table.volume") as string, sortable: true, width: "80px", align: "right", sortBy: tools.sortBySizeValue },
        validitySize: {
            label: this.$t("pricing.table.validity") as string,
            sortable: true,
            width: "100px",
            align: "right"
        },
        price: {
            label: this.$t("pricing.table.price") as string,
            sortable: true,
            width: "120px",
            align: "right",
            sortBy: (product: Product) => (product.prices ? product.prices[0].priceValue : 0)
        },
        // RRP is a computed value (price × size multiplier), not a DB column, so it can't be sorted server-side.
        defaultRetailPriceInUsd: { label: this.$t("pricing.table.rrp") as string, sortable: false, width: "140px", align: "right" }
    };
    private waitForHtmlElementsTimeout?: ReturnType<typeof setTimeout> = undefined;
    private showWelcomeBonus: boolean = false;
    private activeFilters: ActiveDataPackageFilters = {};
    private currentSortBy?: string = undefined;
    private currentSortDir?: string = undefined;

    get pagedProducts(): Array<Product> {
        return this.$store.state.pagedProducts;
    }

    get pageIndex(): number {
        return this.$store.state.pageIndex;
    }

    get pageSize(): number {
        return this.$store.state.pageSize;
    }

    get totalPageCount(): number {
        return this.$store.state.totalPageCount;
    }

    get filterOptions() {
        return this.$store.state.filterOptions;
    }

    get filtersLoading(): boolean {
        return this.$store.state.filtersLoading;
    }

    get hasActiveFilters(): boolean {
        const f = this.activeFilters;
        return !!(f.countrySets?.length || f.validityValues?.length || f.sizeValues?.length || f.includeUnlimited || f.packageCategories?.length);
    }

    get isMobile() {
        return this.$store.state.isMobile;
    }

    created() {
        document.title = process.env.VUE_APP_THEME_TITLE + " | " + this.$t("addPackages.pageTitle");
        this.readSortFromRoute();
        this.fetchPage().finally(() => {
            this.isLoading = false;
        });
        this.$store.dispatch("FETCH_DATA_PACKAGE_FILTERS");
    }

    @Watch("pagedProducts")
    onPagedProductsChange(products: Array<Product>) {
        products.forEach((p: Product) => {
            if (!this.selectedAmounts[p.id]) {
                this.$set(this.selectedAmounts, p.id, 0);
            }
        });
    }

    // TableList persists sort in the URL query (sortKey/sortDir); react by refetching server-side.
    @Watch("$route.query")
    onRouteQueryChange() {
        this.readSortFromRoute();
        this.fetchPage(0);
    }

    @Watch("isMobile")
    isMobileChanged() {
        if (this.showWelcomeBonus) this.cartBoxIsOpen = true;
        else this.cartBoxIsOpen = false;
    }

    private getEmojiFlag(countryCode: string): string {
        return emojiFlag(countryCode, "🌏");
    }

    private coverageLabel(item: Product): string {
        switch (coverageTypeOf(item)) {
            case "worldwide":
                return "Worldwide";
            case "region":
                return "Region";
            default:
                return "Single country";
        }
    }

    private readSortFromRoute() {
        const sortKey = this.$route.query.sortKey as string | undefined;
        const sortDir = this.$route.query.sortDir as string | undefined;
        this.currentSortBy = sortKey ? this.mapSortKey(sortKey) : undefined;
        this.currentSortDir = sortDir || undefined;
    }

    private mapSortKey(columnKey: string): string | undefined {
        switch (columnKey) {
            case "coverage":
                return "coverage";
            case "sizeValue":
                return "volume";
            case "validitySize":
                return "validity";
            case "price":
                return "price";
            default:
                return undefined;
        }
    }

    private fetchPage(pageIndex: number = this.pageIndex) {
        return this.$store.dispatch("FETCH_DATA_PACKAGES_PAGE", {
            pageIndex,
            pageSize: this.pageSize,
            // Default to coverage order (worldwide packs first).
            sortBy: this.currentSortBy ?? "coverage",
            sortDir: this.currentSortDir,
            ...this.activeFilters
        });
    }

    private onFilterChange(filters: ActiveDataPackageFilters) {
        this.activeFilters = filters;
        this.fetchPage(0);
    }

    private onPageChange(index: number) {
        this.fetchPage(index);
    }

    private openDetailModal(item: Product) {
        this.modalPackage = item;
        this.showPackageModal = true;
    }

    private closeDetailModal() {
        this.modalPackage = undefined;
        this.showPackageModal = false;
    }

    // extra local method because vue can not access tools directly in template
    private getVolume(item: Product): string {
        return tools.getVolume(item);
    }
}
